import request from '@/utils/request'

// 查询资金流水列表分页
export function fetchList(query) {
    return request({
        url: '/sys/fund/flowing/page',
        method: 'get',
        params: query
    })
}
// 删除资金流水
export function delFlowObj(data) {
    return request({
        url: '/sys/fund/flowing/delete',
        method: 'post',
        data: data
    })
}
// 获取资金流水详情
export function getFlowDetail(id) {
    return request({
        url: '/sys/fund/flowing/detail',
        method: 'get',
        params: { id }
    })
}
// 查询资金提现列表分页
export function fetchWithdrawalList(query) {
    return request({
        url: '/sys/fund/withdrawal/page',
        method: 'get',
        params: query
    })
}
// 查询资金提现title统计
export function getWithdrawalStatistics(query) {
    return request({
        url: '/sys/fund/withdrawal/statistics/title',
        method: 'get',
        params: query
    })
}
// 审核资金提现
export function auditWithdrawal(data) {
    return request({
        url: '/sys/fund/withdrawal/audit',
        method: 'post',
        data: data
    })
}
// 删除资金提现
export function delWithdrawalObj(data) {
    return request({
        url: '/sys/fund/withdrawal/delete',
        method: 'post',
        data: data
    })
}
// 获取资金提现详情
export function getWithdrawalDetail(id) {
    return request({
        url: '/sys/fund/withdrawal/detail',
        method: 'get',
        params: { id }
    })
}
// 审核统计
export function getWithdrawalCount(query) {
    return request({
        url: '/sys/fund/withdrawal/count',
        method: 'get',
        params: query
    })
}
// 查询资金提现列表分页(代理商)
export function fetchWithdrawalAgentList(query) {
    return request({
        url: '/fund/withdrawal/page/agent',
        method: 'get',
        params: query
    })
}
// 查询资金提现列表分页(场地)
export function fetchWithdrawalSiteList(query) {
    return request({
        url: '/fund/withdrawal/page/site',
        method: 'get',
        params: query
    })
}
// 查询资金账户
export function connectPage(query) {
    return request({
        url: '/sys/fund/connect/page',
        method: 'get',
        params: query
    })
}
// 调整金豆
export function addObj(data) {
    return request({
        url: '/sys/fund/connect/add01',
        method: 'post',
        data: data
    })
}
// 调整金豆
export function phoneNorMal(data) {
    return request({
        url: '/system/user/check/phone/normal',
        method: 'post',
        data: data
    })
}
// 调整积分
export function addObj1(data) {
    return request({
        url: '/sys/fund/connect/add02',
        method: 'post',
        data: data
    })
}
// 删除品牌报单
export function delObj(data) {
    return request({
        url: '/taxation/brand/delete',
        method: 'post',
        data: data
    })
}
// 查询资金提现配置列表
export function fetchWithdrawalConfigList(query) {
    return request({
        url: '/sys/fund/withdrawal/config/list',
        method: 'get',
        params: query
    })
}
// 新增资金提现配置
export function addWithdrawalConfig(data) {
    return request({
        url: '/sys/fund/withdrawal/config/add',
        method: 'post',
        data: data
    })
}
// 编辑资金提现配置
export function editWithdrawalConfig(data) {
    return request({
        url: '/sys/fund/withdrawal/config/edit',
        method: 'post',
        data: data
    })
}
// 获取资金提现配置详情
export function getWithdrawalConfigDetail(roleType, id) {
    const params = { roleType }
    if (id !== undefined && id !== null) {
        params.id = id
    }
    return request({
        url: '/sys/fund/withdrawal/config/detail',
        method: 'get',
        params: params
    })
}
// 删除资金提现配置
export function delWithdrawalConfig(data) {
    return request({
        url: '/sys/fund/withdrawal/config/delete',
        method: 'post',
        data: data
    })
}
// 调整余额
export function adjustBalance(data) {
    return request({
        url: '/sys/fund/connect/add',
        method: 'post',
        data: data
    })
}